<!-- #3 -->
<template>
  <v-col class="pl-0 pr-0">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Client API Summary
      </div>
    </div>
    <v-divider class="mt-1 mr-8 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loader"
      class="elevation-1 custom-icon-size mr-8"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row">
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field label="SKU" outlined v-model="sku"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="External Receipt Number"
                  outlined
                  v-model="external_receipt_number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="Receipt Line No"
                  outlined
                  v-model="receipt_linenumber"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="transaction_type"
                  label="Transaction Type"
                  :items="transactions"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field label="LOT" outlined v-model="lot"></v-text-field>
              </v-col>

              <v-col
                class="pr-4"
                sm="
                6
                "
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-5"></v-divider>
        </template>
      </template>
      <template v-slot:[`item.updated_datetime`]="{ item }">
        <span v-if="item.updated_datetime">{{
          item.updated_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.created_datetime`]="{ item }">
        <span v-if="item.created_datetime">{{
          item.created_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.transaction_date`]="{ item }">
        <span v-if="item.transaction_date">{{
          item.transaction_date
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>

      <template v-slot:[`item.receipt_key`]="{ item }">
        {{ item.receipt_key }}<br />({{ item.external_receipt_number }})
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          @click="retry(item)"
          icon
          v-if="
            checkPermission(
              'app_infor:client_api_retrigger_failed_transactions'
            )
          "
        >
          <v-icon> mdi-refresh </v-icon>
        </v-btn>
        <v-btn
          @click="open(item)"
          icon
          v-if="
            checkPermission(
              'app_infor:client_api_retrigger_failed_transactions'
            )
          "
        >
          <v-icon> mdi-pencil </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="400">
      <v-form ref="form" class="pt-0 pl-0">
        <v-card>
          <v-card-title class="headline">Add Comment </v-card-title>
          <v-divider class="mb-2"></v-divider>
          <v-card-text class="pb-0 pt-0">
            <v-text-field
              v-model="comment"
              label="Comment"
              outlined
              dense
              class="required"
              :rules="[(v) => !!v || 'Comment is required.']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pl-4 pt-0">
            <v-btn
              color="green darken-1"
              class="error"
              @click="
                (dialog = false),
                  (comment = ''),
                  (selectedItem = {}),
                  $refs.form.reset()
              "
            >
              Cancel
            </v-btn>
            <v-btn color="primary darken-1" @click="updateItem"> Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {},
  computed: {},
  data: () => ({
    external_receipt_number: "",
    sku: "",
    lot: "",
    warehouse_id: "",
    receipt_linenumber: "",
    transaction_type: "",

    options: {},
    transactions: ["Putaway", "NormalASN"],
    total: 0,
    comment: "",
    headers: [
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Warehouse",
        value: "warehouse_id__name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Receipt Key (External Receipt)",
        value: "receipt_key",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "120px",
      },
      {
        text: "Receipt Line Number",
        value: "receipt_linenumber",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Transaction Id",
        value: "transaction_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Transaction Type",
        value: "transaction_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Transaction Date",
        value: "transaction_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "LOT",
        value: "lot",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Quantity",
        value: "quantity",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Comment",
        value: "comment",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At",
        value: "created_datetime",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated_datetime",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    list: [],
    loader: false,
    dialog: false,
    getWarehouseStores: [],
    selectedItem: {},
    filtersArr: [],
    warehouses: [],
  }),

  created() {
    this.getwarehouse();
  },
  watch: {
    options: {
      handler() {
        this.fetchClientAPiSummary();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getClientApiTrackingSummary",
      "clientTrackingRetriger",
      "snackBar",
      "clientTrackingEdit",
      "getInforWarehouseList",
    ]),
    allFilters() {
      this.clientsLoader = true;

      let obj = {
        warehouse_id: this.warehouse_id,
        sku: this.sku ? this.sku.trim() : this.sku,
        lot: this.lot ? this.lot.trim() : this.lot,
        external_receipt_number: this.external_receipt_number
          ? this.external_receipt_number.trim()
          : this.external_receipt_number,
        receipt_linenumber: this.receipt_linenumber
          ? this.receipt_linenumber.trim()
          : this.receipt_linenumber,
        transaction_type: this.transaction_type,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.options.itemsPerPage = 25;

      this.allFilters();
      this.fetchClientAPiSummary();
    },
    clearAll() {
      this.external_receipt_number = "";
      this.sku = "";
      this.lot = "";
      this.warehouse_id = "";
      this.receipt_linenumber = "";
      this.transaction_type = "";
      this.allFilters();

      this.fetchClientAPiSummary();
    },
    getwarehouse() {
      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },
    fetchClientAPiSummary() {
      this.loader = true;
      this.getClientApiTrackingSummary({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.loader = false;
          this.total = res.data.total;
          this.list = res.data.records;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    open(item) {
      this.selectedItem = item;
      this.dialog = true;
    },

    updateItem() {
      if (this.$refs.form.validate()) {
        let payload = {
          request_type: "edit",
          comment: this.comment,
        };
        let data = {
          data: payload,
          id: this.selectedItem.id,
        };
        this.clientTrackingEdit(data)
          .then((res) => {
            this.loader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.fetchClientAPiSummary();
            this.dialog = false;
            this.selectedItem = {};
            this.comment = "";
          })
          .catch(() => {
            this.loader = false;
            this.dialog = false;
            this.selectedItem = {};
            this.comment = "";
          });
      }
    },
    retry(item) {
      let data = {
        id: item.id,
        request_type: "retrigger",
      };
      this.clientTrackingRetriger(data)
        .then((res) => {
          this.loader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.fetchClientAPiSummary();
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 0px 5px 5px !important;
}
.p-0 {
  padding: 0px !important;
}
</style>
